const apiUrl = {
  API_URL: process.env['REACT_APP_API_URL'],
  WS_URL: process.env['REACT_APP_WS_URL'],
};
export default apiUrl;
